import { IUser, IUserType } from '../../../types/record/user';
import {
  IUserAPIValidationErrorFactory,
  IUserAPIValidationErrorType,
  UserAPIRawSuccessResponseType,
  UserAPIRawValidationErrorType
} from '../../types/user/api-response';
import { nullableToStringList } from '../nullable-to-string-list';

export const IUserFromAPISuccessResponse = ({
  id,
  username,
  email,
  is_active,
  my_project_count,
  approved_project_count,
  can_be_deleted,
  created_at,
  updated_at
}: UserAPIRawSuccessResponseType): IUserType =>
  IUser({
    id,
    name: username,
    email,
    isActive: is_active,
    numProjectsCreated: my_project_count,
    numProjectsApproved: approved_project_count,
    canBeDeleted: can_be_deleted,
    dateCreated: new Date(created_at).getTime(),
    dateUpdated: new Date(updated_at).getTime()
  });

export const IUserAPIValidationError = ({
  username,
  email,
  password,
  is_active
}: UserAPIRawValidationErrorType): IUserAPIValidationErrorType =>
  IUserAPIValidationErrorFactory({
    name: nullableToStringList(username),
    email: nullableToStringList(email),
    password: nullableToStringList(password),
    isActive: nullableToStringList(is_active)
  });
